module.exports = __webpack_public_path__ + "media/images/share/vk-df330cb026e03635b184f1d83c3dbc30.svg";